import { MLanguage } from 'vue-multilanguage';

export default new MLanguage('es-es').create({
    // Header
    safeEnvironment: 'Ambiente',
    safeEnvironmentSuffix: ' 100% Seguro',

    //Footer
    developedBy: 'Desarrollado por',
    securePayment: 'Pago seguro',

    // Link Info
    linkInfo: 'Ha enviado una solicitud de pago',

    // Total Overview
    totalAmount: 'Valor total',
    delivery: 'Entrega',
    deliveryAddress: 'Dirección de entrega',
    payment: 'Pago',
    paymentDate: 'Fecha de pago',

    // Cart Overview
    purchaseSummary: 'Resumen de la compra',
    productOrServiceDescription: 'Descripción del producto o servicio',
    showDescription: 'Mostrar descripción',
    hideDescription: 'Ocultar descripción',

    // Cart Items
    more: 'más',
    showLess: 'mostrar menos',
    seeAllItems: 'Ver todos los elementos',
    hideItems: 'Ocultar los elementos',

    // Shipping Method Overview
    within2Hours: 'Dentro de 2 horas',
    withinOneBusinessDay: 'En el plazo de 1 día laborable',
    withinAnyBusinessDays: 'En el plazo de {0} día laborable',
    free: 'Gratis',

    // Common
    of: 'de',
    off: 'de descuento',
    cartDiscount: 'Descuento del carrito',
    discountOn: 'Descuento en',
    zipcode: 'Código Postal',
    street: 'Dirección',
    addressLine1: 'Dirección Línea 1',
    addressLine2: 'Dirección Línea 2 (Opcional)',
    number: 'Número',
    complement: 'Complemento',
    district: 'Barrio',
    city: 'Ciudad',
    state: 'Estado',
    province: 'Provincia',
    cpf: 'CPF',
    cnpj: 'CNPJ',
    foreign: 'Extranjero',
    foreigner: 'Estado, provincia, distrito (sigla)',
    continue: 'Continuar',
    confirmPayment: 'Confirmar pago',
    back: 'Volver',
    cancel: 'Cancelar',
    thanks: '¡Gracias!',
    notAvailable: 'No disponible',
    copyCode: 'Copiar código',
    retry: 'Inténtalo de nuevo',
    copied: 'Copiado',
    identityConfirmation: 'Confirmación de identidad',
    confirmIdentity: 'Confirmar identidad',

    // Address
    chooseYourState: 'Seleccione su Estado',
    chooseYourProvince: 'Seleccione su Provincia',
    forgotIt: 'Me olvidé',

    // Shipping Type
    selectDeliveryType: 'Seleccione el tipo de envío',
    shippingAddressInfo: 'Introduzca la dirección de envío',
    freight: 'Transporte',
    freightDefined: 'Transporte definido',

    // Change Payment Type
    chooseHowYouWantToPay: 'Elige cómo quieres pagar',
    orChooseOtherWays: 'o elige otras formas',
    otherPaymentMethods: 'Otros métodos de pago',
    expressPayment: 'Pago con tarjeta exprés',

    // Personal Data
    personalDataSubtitle: '¡Falta poco! Introduzca sus datos antes de concluir',
    fullName: 'Nombre Completo',
    email: 'Correo electrónico',
    cellPhone: 'Teléfono Móvil',
    identity: 'Número del documento',
    identityC2P: 'Número del documento',
    billingAddress: 'Dirección de facturación',
    termsPreffix: 'He leído y acepto',
    termsSuffix: ' las condiciones de uso',
    privacyPreffix:
		'Quiero recibir promociones personalizadas de los socios comerciales de Cielo, Más detalles se pueden encontrar en',
    privacySuffix: ' Política de Privacidad',
    completePurchase: 'Concluir compra',
    sameAddressOption:
		'Mi dirección de facturación es la misma que la de envío',

    // Billing Address
    nationalAddress: 'Dirección nacional',
    internationalAddress: 'Dirección internacional',
    national: 'Nacional',
    international: 'Internacional',

    // Card Payment
    paymentByCreditCard: 'Pago por tarjeta de crédito',
    paymentByDebitCard: 'Pago con tarjeta de débito',
    paymentByVoucherCard:
		'Pago con voucher de alimentación / cheque restaurant',
    paymentByMultibenefits: 'Pago con tarjeta multibeneficio',
    paymentByGooglePay: 'Pago con Google Pay',
    cardName: 'Nombre',
    expiration: 'Validez',
    securityCode: 'Código de seguridad',
    cardNameHolder: 'Nombre del titular (como en la tarjeta)',
    cardNameHolderValidation: 'Nombre del titular',
    cardNumber: 'Número de la tarjeta',

    // Payment Success
    paymentSuccessTitle: '¡Su pedido ha sido realizado con éxito!',
    paymentSuccessDetail:
		'¡Gracias por comprar en {0}, socio de Cielo! Puede hacer seguimiento al estado de su pago en nuestra página de ',
    paymentSuccessButtonLabel: 'Consultar Pedidos',

    // Loggi Message
    loggiThanksMessage: 'Gracias por comprar con nosotros ',
    loggiSuccessTitle:
		'Su pedido ha sido realizado y estamos confirmando el pago.',
    loggiSuccessBody:
		'En breve recibirá un SMS de Loggi para seguir el progreso de su pedido. Y toda la información sobre tu compra ha sido enviada a tu correo electrónico:',
    requestNumber: 'Número de pedido',

    // Boleto Message
    boletoSuccessBody:
		'Para completar su compra realice el pago del boleto. El pago se aprobará en 1 o 2 días laborables.',
    barcode: 'Código de barras',
    openBoleto: 'Abrir boleto',

    // Pix Finalize
    pixSuccessBody:
		'Para completar tu compra efectúa el pago Pix. El pago se aprobará en la misma hora.',
    qrcodeExplanation:
		'También puede pagar a través de QRCode. Simplemente escanéalo desde otro dispositivo móvil',
    paywithPixSuccessFooter: 'Pague con',
    advertisingPixSuccessFooter: 'Disponible en Google Play y Apple Store',

    // Payment Methods
    creditCard: 'Tarjeta de crédito',
    creditCardText: 'Ingrese los datos de la tarjeta',
    debitCard: 'Tarjeta de débito',
    debitCardText: 'Ingrese los datos de la tarjeta',
    boleto: 'Boleto Bancario',
    pix: 'Pix',
    pixText: 'Pague al instante',
    qrCodePay: 'Qr Code Crédito',
    qrCodePayText: 'Escanee el código QR',
    voucher: 'Voucher de alimentación / Cheque restaurant',
    qrCodeDebit: 'Qr Code Débito',
    qrCodeDebitText: 'Escanee el código QR',
    clickToPay: 'ClickToPay',
    multibenefits: 'Tarjeta multibeneficio',
    multibenefits2: 'Alimentación y Comida',
    googlePay: 'Google Pay',
    applePay: 'Apple Pay',
    pixOpenFiance: 'Pix con Open Finance',
    paymentByPixOpenFinance: 'Pago con Pix Open Finance',
    pixTypePixText: 'Escanee o copie el código',
    pixTypeOpenFinanceText: 'Pague con su banco',
    recommendedBadge: 'Recomendado',

    // Card Installments
    chooseInstallmentsNumber: 'Seleccione el número de cuotas',
    installmentsNumber: 'Número de Cuotas',
    installmentsItem: '{quantity}x de R$ {installmentPrice} (sin interés)',
    installment: 'Plan de pago',
    installmentSupportText: 'Proporcione el número de la tarjeta para verificar el valor de las cuotas',

    // Popups
    addressSearchZipcode:
		'Por favor, espere, estamos comprobando su código postal',
    addressZipcodeNotFound:
		'No encontramos la información de la dirección basada en este código postal, continúe completando los campos',
    addressUnderstood: 'Entendí',
    warning: 'Aviso',
    paymentProviderPurchaseError:
		'Se ha producido un error al procesar su compra',
    wait: 'Por favor, espere',
    unexpectedError: 'Se ha producido un error inesperado.',
    withoutMessage: 'Sin mensaje',
    qrCodeGenerationError:
		'Se ha producido un error al generar el qrcode de su transacción. Vuelva a abrir el link y repita el proceso de pago.',
    finalizingPaymentError: 'Error al finalizar el pago',
    unknownPaymentError: 'Error desconocido al finalizar el pago',
    chooseYourProvince: 'Seleccione su Provincia.',
    unableCalculateShippingCost:
		'Lamentablemente, no podemos calcular el valor del flete.',
    invalidExpirationDate: 'Fecha de vencimiento no válida',
    processingRequestError: 'Error al procesar la solicitud',
    cardBrandNotSupported: 'Tarjeta no suportada',
    applePayErrorTitle: 'Error al procesar el pago con Apple Pay',
    applePaySesssionError: 'Error al crear la sesión de Apple Pay. Por favor, seleccione otro método de pago o contacte con la tienda.',
    applePayContactFieldError: 'Por favor, verifique si todos los datos personales y de dirección de facturación están correctamente registrados en su dispositivo iOS e inténtelo de nuevo.',
    applePayCompletePaymentError: 'Error al completar el pago con Apple Pay. Por favor, seleccione otro método de pago o contacte con la tienda.',
    applePayBillingContactError: 'Por favor, verifique si todos los datos de dirección de facturación de la tarjeta están correctamente registrados en su dispositivo iOS e inténtelo de nuevo.',
    applePayShippingContactError: 'Por favor, verifique si todos los datos personales están correctamente registrados en su dispositivo iOS e inténtelo de nuevo.',

    // message codes
    cardExpired:
		'La fecha de validez de la tarjeta ha expirado. Por favor, elija otra tarjeta',
    couldNotCalculateFreight:
		'No fue posible calcular el valor del envío. Por favor, introduzca de nuevo su código postal de entrega.',
    fillWithFullName: 'Introduzca su nombre completo',
    finalizePaymentError:
		'No fue posible finalizar el pedido. Contacte lo establecimiento.',
    indentifyInvalid: 'Número de Documento Inválido',
    internationalBillingAddressIsNotEnabled:
		'No es posible enviar datos de facturación internacional',
    invalidCardNumber: 'Número de tarjeta inválido',
    invalidCheckoutCieloCard:
		'La tarjeta Elo introducida no es una tarjeta de crédito válida para las compras en Checkout Cielo.',
    invalidCvv: 'Código de seguridad inválido.',
    invalidFlagForCardNumber:
		'La bandera seleccionada no es válida para el número de tarjeta introducido',
    invalidFormZipcodeMandatory: 'Formulario inválido. Código postal requerido',
    orderAlreadyProcessedMessage: 'Su pedido ya está siendo procesado.',
    pleaseInformHolder: 'Introduzca el nombre completo del titular',
    productRemovedOrNotFound:
		'El producto solicitado no se ha encontrado o ya no está disponible.',
    wrongOperationResultSafetyCheck:
		'El resultado de la operación es erróneo (control de seguridad)',
    openFinanceUrlIsNull: 'Por favor, inténtelo de nuevo.',
    tryCreateNewLink: 'Por favor, contacte con la tienda para generar un nuevo enlace de pago.',

    // title message codes
    opsTitle: 'Oppsss!',
    openFinanceUrlIsNullTitle: 'Error al redirigir al banco',

    // mpi
    cardAuthenticationError:
		'Se ha producido un error de autenticación. Por favor, seleccione otra tarjeta u otro método de pago.',
    notAuthenticableCardError:
		'Tarjeta no autenticable. Por favor, seleccione otra tarjeta u otro método de pago.',
    unexpectedAuthenticationError:
		'Se ha producido un error de autenticación inesperado. Por favor, inténtelo de nuevo o seleccione otro método de pago.',
    flagDoesNotSupport:
		'Bandera no admite la autenticación. Por favor, seleccione otra tarjeta u otro método de pago.',

    // qr code pay
    qrCodePayTitle: 'Pago por QR Code Pay',
    payWithQrCodeSuccessFooter: 'Pague con',
    mobileAppAvailable: 'Disponible en Google Play y Apple Store',
    qrCodePayExplanation:
		'Para completar su compra realice el pago escaneando el QR Code que aparece a continuación. Basta escanearlo desde otro dispositivo móvil.',

    // Order response overview
    customerName: 'Nombre',
    orderNumber: 'Número de pedido',
    documentNumber: 'Documento',
    orderDate: 'Fecha de pedido',

    //ClickToPay Infos
    clickToPayText: 'Compras más rápidas con tu tarjeta de crédito.',
    clickToPayCTAText: 'Sobre el Click to Pay',
    clickToPayIdentityInfo:
		'La información será utilizada por Click to Pay para validar su identidad.',
    clickToPayLegalPersonInfo:
		'Click to Pay no está disponible para personas jurídicas. Si este es tu caso, ',
    clickToPayChangePaymentMethodCTA: 'cambia tu método de pago aquí.',

    clickToPayModalTitle: 'Click to Pay',
    clickToPayModalDescriptionFlags:
		'Un método de pago rápido y seguro, compatible con Mastercard y Visa',
    clickToPayModalDescriptionProtectedInf: 'Mantenga su información segura',
    clickToPayModalDescriptionUseWorld: 'Uso en tiendas de todo el mundo.',
    clickToPayModalDescriptionSimplePayment:
		'Configure una vez y realice pagos sin problemas en el futuro',

    clickToPayNewCardFormHeader: 'Detalles de la tarjeta de crédito',

    clickToPayAllowCheckout1: 'Registre mi información con ',
    clickToPayAllowCheckout2: ' en Click To Pay para compras más rápidas y seguras.',

    clickToPayRememberMe: 'Recuerda mis tarjetas en este navegador.',
    clickToPayAgreementText1: 'Al continuar, aceptas las',

    clickToPayAgreementTerms: 'Términos ',

    clickToPayAgreementText2: 'y entiendo que sus datos serán tratados de conformidad con las',
    clickToPayAgreementPrivacyTerms: 'Estándares de privacidad.',
    clickToPayAllowSaveCard: 'Guardar mi tarjeta en Click to Pay para compras rápidas y seguras.',
    clickToPaySaveYourCard: 'Guarda tu tarjeta',
    clickToPayWithSavedCard: 'Pagar con tarjeta guardada',

    otpTitle: 'Accede a tus tarjetas',
    otpDescriptionInsertCode:
		'Introduzca el código de autenticación enviado por',
    otpDescriptionToEmail: 'al e-mail',
    otpWrongEmail: '¿El e-mail está mal?',
    otpResendCode: 'Reenviar codigo',
    otpRememberMe: 'Recuerda mis tarjetas en este navegador',
    otpInvalidCodeError:
		'Codigo invalido. Vuelve a enviar el código o inténtalo de nuevo',
    otpInaccessibleError:
		'La cuenta no está disponible actualmente. Vuelve a intentarlo más tarde',
    otpRetriesExceededError:
		'Se ha excedido el número de reintentos. Vuelve a intentarlo más tarde',
    otpUnknownError:
		'No se puede acceder a esta cuenta. Vuelve a intentarlo más tarde',

    // ClickToPay Redesign
    paymentWithC2P: 'Pago con Click to Pay',
    accessYourSavedCards: 'Accede a tus tarjetas guardadas',
    howC2PUses: '¿Cómo usa Click to Pay mi información?',
    howC2PUsesTooltipText: 'Click to Pay utilizará tu número de teléfono y correo electrónico para verificar si hay tarjetas guardadas. Se puede enviar un código a tu teléfono para verificar tu identidad. Pueden aplicarse cargos por mensajes de texto.',
    addCard: 'Agregar tarjeta',
    rememberCards: 'Recordar tarjetas en este navegador',
    rememberCardsTooltipText1: 'Con la tarjeta guardada en el navegador, no pasarás por la verificación y podrás acceder a tus tarjetas de manera rápida y segura en Click to Pay.',
    rememberCardsTooltipText2: 'No se recomienda guardar en dispositivos públicos o compartidos.',
    edit: 'Editar',
    c2pAgreementText: 'Al continuar, aceptas el registro de tu tarjeta con Click to Pay.',
    c2pAgreementTerms: 'Términos y condiciones de ',
    and: 'y',
    c2pCardVerifying: 'Click To Pay está verificando si hay tarjetas guardadas',
    finishPaymentTitle: '¡Ya casi! Ingresa tu número del documento antes de finalizar',
    yourPersonalData: 'Tus datos personales',

    // Checkout errors
    errorCheckoutHeading: 'No se puede continuar',
    errorCheckoutBody: 'Elige otra tarjeta o cambia tu método de pago',

    //Contact view
    contactTitle: 'Datalles de contacto',
    chooseCountry: 'Selecciona el pais',
    selectCountry: 'Seleccionar',
    errorOTPHeading: 'Error al validar datos',
    errorOTPBody: 'Elija otro método de pago o inténtelo nuevamente.',
    errorOTPCTA: 'OK entendí',

    //Personal view
    PersonalTitle: 'Datos personales',

    //Card list view
    cardListTitle: 'Tarjetas guardadas en Click to Pay',
    enterYourDocument: 'Introduce tu documento',
    chooseTheNumberOfInstallments: 'Elige el número de cuotas',
    chooseInstallmentsNumberV2: 'Número de plazos',
    areTheCardsNotYours: '¿No son tuyas las tarjetas?',
    showAllCards: 'Mostrar todas las tarjetas',
    hideCardList: 'Ocultar lista de tarjetas',
    addNewCard: 'Agregar nueva tarjeta',
    locked: '(Bloqueada)',
    expired: '(Expirada)',
    lockedAndExpired: '(Bloqueada) (Expirada)',
    thisCardIsLocked: 'Esta tarjeta está bloqueada.',
    thisCardIsExpired: 'Esta tarjeta ya expiró.',
    thisCardIsLockedAndExpired: 'Esta tarjeta está bloqueada y expirada.',

    //Order status, invalid url and invalid order views
    orderStatus: 'Estado del pedido',
    invalidUrlTitle: 'La página que estás buscando no existe',
    invalidUrlText: 'Verifica la escritura e inténtalo de nuevo.',
    invalidOrderTitle: 'Servicio temporalmente no disponible',
    invalidOrderText: 'Lamentablemente, no es posible continuar en este momento. Por favor, inténtalo de nuevo más tarde.',
    update: 'Actualizar',
    paymentUnderReview: 'Pago en revisión',
    paymentUnderReviewText1: 'La confirmación del pago se realiza después de la aprobación de {0}.',
    paymentUnderReviewText2: 'Sigue el estado del pago en nuestra página de ',
    paymentDenied: 'Pago denegado',
    paymentDeniedText: 'Verifica los datos de la tarjeta o intenta nuevamente utilizando otro método de pago.',
    paymentApproved: 'Pago aprobado',
    paymentApprovedText: 'Has pagado {0}.',
    paymentSummary: 'Resumen del pago',
    paymentDate: 'Fecha de pago',
    paymentRefused: 'Pago rechazado',
    idPayConfirmation: 'Para garantizar la seguridad de su compra, necesitamos la confirmación de la identidad de la persona titular de la tarjeta utilizada para la compra, en el plazo de 1 hora.',
    confirmationInProgress: 'Confirmación en progreso',
    idPayRedirectText: 'Por favor, espere unos segundos mientras procesamos la confirmación de identidad.',
    openFinanceRedirectError: 'Ocurrió un error',
    openFinanceRedirectErrorText: 'No pudimos redirigirlo al banco, pero puede intentar realizar el pago nuevamente más tarde.',
    changePaymentType: 'Cambiar método de pago',
    openFinanceInterrupted: 'No fue posible realizar el Pix a través de Open Finance',
    openFinanceInterruptedText: 'La transacción fue interrumpida. Puede seleccionar otro banco, cambiar el método de pago o intentar nuevamente más tarde.',
    openFinanceWrongData: 'Sus datos de identificación son incorrectos',
    openFinanceWrongDataText: 'Verifique sus datos personales para confirmar la transacción o cambie el método de pago.',
    openFinanceWaitingConfirm: 'Espere la confirmación del pago de su banco dentro de 30 minutos.',
    openFinanceCancel: 'Quiero cancelar el pago',
    openFinanceCancelModalTitle: 'Cancelación de pago',
    openFinanceCancelModalText: '¿Está seguro de que desea cancelar el pago? Esta acción no se puede deshacer.',
    openFinanceCancelModalConfirm: 'Sí, cancelar',
    paymentCanceled: 'Pago cancelado',
    paymentCanceledText: 'Su pago fue cancelado con éxito y no se debitará ningún monto de su cuenta.',
    employerNumber: 'CNPJ da loja',
    transactionId: 'ID de transacción',

    //Pix Type View
    changePixTypeTitle: 'Opciones Pix para pago',
    changePixTypeOpenFinanceInfo1: '¡Con Pix a través de Open Finance, tus pagos serán rápidos y seguros!',
    changePixTypeOpenFinanceInfo2: 'Ya no necesitarás salir del checkout para ir al banco a pagar.',
    pixTypeFilterBank: '¿De qué banco quieres pagar?',
    pixTypeSuggestions: 'Todos los bancos',
    pixTypeEmptySearchTitle: 'Banco no encontrado',
    pixTypeEmptySearch:'Asegúrese de que el nombre del banco esté escrito correctamente; de ​​lo contrario, es posible que no forme parte de la iniciativa Open Finance.',
    pixOFOrderReviewTitle: 'Banco seleccionado',
    pixOFOrderReviewRedirectWarning1: 'Para concluir, vamos redirigirlo a ',
    pixOFOrderReviewRedirectWarning2: ', necesita tener saldo allí.',
    pixOpenFinanceRedirect: 'Autorización de pago',
    pixOpenFinanceRedirectLoading1: ' Estamos concluyendo su pago en Cielo',
    pixOpenFinanceRedirectLoading2: 'Por favor, espere unos momentos.',
    pixOpenFinanceSecurityRedirect: 'Esta redirección se realiza de forma segura a través de Open Finance.',
    pixOpenFinancePayToday: 'Pague hoy',
    pixOpenFinanceLoadingBanks: 'Cargando bancos',
    pixOpenFinanceGoNowToBank: 'Ir ahora para',

    //CVVAlert
    securityCVV: 'Por motivos de seguridad, introduce tu CVV',
    send: 'Mandar',

    //v2

    inputCVV: 'CVV',
    inputCardHolderName: 'Nombre como aparece en la tarjeta',
    inputCardDueDate: 'Fecha de vencimiento',
    titleViewCredCard: 'Pago con tarjeta de crédito',
    titleViewDebitCard: 'Pago con tarjeta de débito',
    titleViewQrCodeCred: 'Pago mediante Código QR de crédito',
    titleViewMultibenefitsCard: 'Alimentación y Comida',
    titleViewGooglePay: 'Pago con Google Pay',
    titleViewApplePay: 'Pago con Apple Pay',
    textViewMultibenefitsCard: 'Usar con el voucher de Elo',
    installmentsExplanationV2: 'Elige el número de cuotas',
    qrcodeExplanationV2: 'También puedes pagar mediante QRCode. Solo escanea desde otro celular',
    whatPayment: 'Cómo desea realizar el pago?',
    orderReview: 'Revisión del pedido',
    pixDescription: 'También puedes pagar mediante QRCode',
    qrcodeTitle: 'Para completar su pago, escanee el código QR a continuación',
    qrcodeInstruction: 'Abra el enlace de aceptación del Código QR (billeteras digitales) en una nueva pestaña del navegador:',
    textInstructionPayment: 'Instrucciones para realizar el pago',
    textInstructionPayment2: 'Utilice billeteras digitales para realizar pagos:',
    numberCardError: 'Numero de tarjeta invalido',
    dateMonthCardError: 'Mes no válido. Debe estar entre 1 y 12.',
    cardExpirationError: 'La fecha de vencimiento debe ser en el futuro.',
    new: 'Nuevo',
    yourDocumentNumber: '',

    // Select Phone
    countryCode: 'Seleccionar código de país',
    selectCountryCode: 'Código de país',

	 // Select Document Type
	 documentType: 'Seleccione el tipo de documento',
	 selectDocumentType: 'Elige el tipo de documento',

	 // Select Country
	 country: 'Selecciona el pais',
	 selectCountry: 'pais',
    wrongFlowMultibenefitsError: 'Este parece ser una tarjeta de alimentación y comida. Por favor, ingrese los datos de la tarjeta de crédito.',
    verifyCardMultibenefitsError: 'erifica el número de tu tarjeta, asegúrate de que sea una tarjeta de alimentación y comida Elo.',
    finishButtonQrCode: 'Generar código QR',
    finishButtonPix: 'Generar código Pix',
    change: 'Cambiar',
    changePayment: 'Cambiar pago',

    //Accessibility
    altLogo: 'Logo de Cielo, con las letras C-I-E-L-O estilizadas en gris y azul sobre un fondo blanco.',
    altLangEn: 'Bandera del Reino Unido, idioma inglés.',
    altLangEs: 'Bandera de España, idioma español.',
    altLangBr: 'Bandera de Brasil, idioma portugués.',
    altPix: 'Imagen del código QR Pix para escanear.',
    altQrCode: 'Imagen del código QR para escanear.',
    ariaLangList: 'Lista de selección de idiomas.',
    ariaShippingTypeList: 'Lista de selección de tipos de entrega.',
    ariaPaymentTypeList: 'Lista de selección de tipos de pago.',
    ariaSelectList: 'Lista de selección de :',
    ariaOrderSummary: 'Resumen del pedido.',
    ariaSeeAllItems: 'Haz clic para mostrar todos los artículos del pedido.',
    ariaShowDescription: 'Haz clic para expandir la descripción.',
    ariaShowOrderSummaryContent: 'Haz clic para expandir el resumen del pedido.',
    ariaCTANull: 'Botón desactivado.',
    ariaCTAC2P: 'Haz clic para seleccionar el método de pago Click to Pay.',
    ariaCTAAboutC2P: 'Haz clic para obtener más información sobre Click to Pay.',
    ariaCTACloseOverlay: 'Haz clic para cerrar la superposición.',
    ariaCTASelect: 'Haz clic para abrir el selector de :',

});
